import { useEffect } from 'react';

import { cartStore } from '@/entities/cart/store/cartStore';
import { getSessionToken } from '@/shared/lib/sessionToken';

export const useCart = () => {
  useEffect(() => {
    getSessionToken();
    cartStore.loadCart();
  }, []);
};